export default __webpack_public_path__ + "static/media/download_button.13aa904c.svg";